import { EnhancedApp } from "@/components/EnhancedApp";
function App() {
  return <EnhancedApp />;
}

export default App;
